module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "div_autre"
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-001"
    }
  }, [_c('h1', {
    staticClass: "pre_tit"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("General preface")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("The aim of this series of Tyndale Old Testament Commentaries, as it was in the companion volumes on the New Testament, is to provide the student of the Bible with a handy, up-to-date commentary on each book, with the primary emphasis on exegesis. Major critical questions are discussed in the introductions and additional notes, while undue technicalities have been avoided.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("In this series individual authors are, of course, free to make their own distinct contributions and express their own point of view on all debated issues. Within the necessary limits of space they frequently draw attention to interpretations which they themselves do not hold but which represent the stated conclusions of sincere fellow Christians.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("The messages of the so-called ‘minor’ prophets Joel and Amos should be as relevant for the reader today as for their original hearers. Dr Hubbard helpfully brings this out as he guides us through the text by which their words come down to us. Joel’s call to repentance and salvation by faith through grace still registers, and his promise of the gift of God’s Holy Spirit reminds us that God’s presence and power are available today to every believer. Amos stresses that crimes against humanity will certainly bring the judgment of God and that we should be more concerned with present spiritual commitment than with past experience, influential though that may be.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("In the Old Testament in particular no single English translation is adequate to reflect the original text. The version on which this commentary is based is the Revised Standard Version, but other ")]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("translations are frequently referred to as well, and on occasion the author supplies his own. Where necessary, words are transliterated in order to help the reader who is unfamiliar with Hebrew to identify the precise word under discussion. It is assumed throughout that the reader will have ready access to one, or more, reliable renderings of the Bible in English.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("Interest in the meaning and message of the Old Testament continues undiminished and it is hoped that this series will thus further the systematic study of the revelation of God and his will and ways as seen in these records. It is the prayer of the editor and publisher, as of the authors, that these books will help many to understand, and to respond to, the Word of God today.")])])]), _c('p', {
    staticClass: "sign"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("D. J. Wiseman")])])])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30d0e461","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre2.vue
// module id = 69
// module chunks = 0